import { render, staticRenderFns } from "./MainMenuHeader.vue?vue&type=template&id=58d5613e&scoped=true&"
import script from "./MainMenuHeader.vue?vue&type=script&lang=js&"
export * from "./MainMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuHeader.vue?vue&type=style&index=0&id=58d5613e&lang=less&scoped=true&"
import style1 from "./MainMenuHeader.vue?vue&type=style&index=1&id=58d5613e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5613e",
  null
  
)

export default component.exports